import React, { createContext, useContext } from "react";

import Swipeable from "@/shared/components/Swipeable/Swipeable";
import { useObserverPattern } from "@/shared/hooks/useObserverPattern";

const GlobalSwipeableContext = createContext({});

export const GlobalSwipeableProvider = ({ className, tag, children }) => {
  const {
    addObserverListener: addSwipedListener,
    removeObserverListener: removeSwipedListener,
    notifyObserverListeners: handleSwiped,
  } = useObserverPattern();

  return (
    <GlobalSwipeableContext.Provider value={{
      addSwipedListener,
      removeSwipedListener,
    }}>
      <Swipeable tag={tag} className={className} onSwiped={handleSwiped}>
        {children}
      </Swipeable>
    </GlobalSwipeableContext.Provider>
  );
};

export const useGlobalSwipeable = () => useContext(GlobalSwipeableContext);
